export type AdminTab = "overview" | "jobs" | "library" | "users" | "settings";

export const ADMIN_TABS: AdminTab[] = ["overview", "jobs", "library", "users", "settings"];
